import { PaymentDto } from 'app/api/apiClient/generated/types';
import { paymentStatusTranslation } from 'app/api/i18n';
import Pill from 'app/components/v2/components/Pill';
import { PayoutStatusId } from 'app/constants/payment';
import { paymentStatusColors } from 'app/constants/status';
import { defaultPaginationParams } from 'app/constants/table';
import { getLanguage } from 'app/utils/lib/i18n';
import { formatCurrency } from 'app/utils/lib/number';

import { PayeePaymentsQueryParams } from './hooks';

export const defaultPayeePaymentsQueryParams: PayeePaymentsQueryParams = {
  endDate: undefined,
  exportReport: undefined,
  factorCompanyId: undefined,
  isFactored: undefined,
  payeeRelationshipId: undefined,
  payorId: undefined,
  payoutTypeFilter: undefined,
  q: undefined,
  sessionCurrencyId: undefined,
  sortAsc: false,
  sortField: 'paidDate',
  startDate: undefined,
  statusId: undefined,
  ...defaultPaginationParams,
};

export const renderPayeePaymentStatus = (payment: PaymentDto) => {
  if (!payment.status?.name) {
    return null;
  }

  return (
    <Pill
      label={paymentStatusTranslation[payment.status.id as PayoutStatusId] ?? payment.status.name}
      statusColor={paymentStatusColors[payment.status.id as PayoutStatusId] ?? 'blue'}
    />
  );
};

export const renderPayeePaymentAmount = (payment: PaymentDto, hasMultiCurrency: boolean): string => {
  if (!payment.totalPaymentAmount) {
    return '';
  }

  const amount = formatCurrency(payment.totalPaymentAmount, payment.payor?.currencyType?.name ?? 'USD');

  return hasMultiCurrency && getLanguage() !== 'en-CA'
    ? `${payment.payor?.currencyType?.name ?? ''} ${amount}`.trim()
    : amount;
};
